import { connect } from "react-redux";
import values from "lodash/values";
import {
	setProductsFilter,
	unsetProductsFilter,
} from "app/pages/Listing/ProductFilters/productsFilterActionCreators";
import { bindActionCreators } from "redux";
import ProductsFilter from "app/pages/Listing/ProductFilters/ProductsFilter";
import {
	getLandingPageBadgeFilterValues,
	getLandingPageDestinationFilterValues,
	getLandingPageMonthFilterValues,
	getLandingPagePeriodFilterValues,
	getLandingPageSelectedFacets,
	getLandingPageTopicFilterValues,
	getLandingPageVisibleFilters,
	shouldDisplayDestinationFilter,
} from "app/pages/LandingPage/landingPageSelector";

const mapStateToProps = state => {
	return {
		productsFilters: state.productsFilters,
		productsActiveFilters: values(state.productsFilters),
		visibleFilters: getLandingPageVisibleFilters(state),
		selectedFacets: getLandingPageSelectedFacets(state),
		destinationFilterValues: getLandingPageDestinationFilterValues(state),
		topicFilterValues: getLandingPageTopicFilterValues(state),
		periodFilterValues: getLandingPagePeriodFilterValues(state),
		monthsFilterValues: getLandingPageMonthFilterValues(state),
		badgesFilterValues: getLandingPageBadgeFilterValues(state),
		displayDestinationFilter: shouldDisplayDestinationFilter(state),
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({ setProductsFilter, unsetProductsFilter }, dispatch);
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ProductsFilter);
